import { render } from "./FileUploadEx.vue?vue&type=template&id=84964496&scoped=true"
import script from "./FileUploadEx.vue?vue&type=script&lang=js"
export * from "./FileUploadEx.vue?vue&type=script&lang=js"

import "./FileUploadEx.vue?vue&type=style&index=0&id=84964496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84964496"]])

export default __exports__